import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_tmp_seller_order_line_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    guid_store_2: fromDatatype.GuidDataFieldInterface;
    location_code_2: fromDatatype.VarcharDatatypeInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    mkp_item_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_code: fromDatatype.VarcharDatatypeInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    sales_order_price: fromDatatype.NumericDatatypeInterface;
    purchase_amount: fromDatatype.NumericDatatypeInterface;
    sales_order_amount: fromDatatype.NumericDatatypeInterface;
    processing_status: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    merchant_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mkp_tmp_seller_order_line_Rowclass implements bl_mkp_tmp_seller_order_line_Rowinterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    guid_store_2: fromDatatype.GuidDataFieldInterface;
    location_code_2: fromDatatype.VarcharDatatypeInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    mkp_item_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_code: fromDatatype.VarcharDatatypeInterface;
    qty_base: fromDatatype.NumericDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    sales_order_price: fromDatatype.NumericDatatypeInterface;
    purchase_amount: fromDatatype.NumericDatatypeInterface;
    sales_order_amount: fromDatatype.NumericDatatypeInterface;
    processing_status: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    merchant_guid: fromDatatype.GuidDataFieldInterface;
}